<template>
  <div class="device-settings">
    <!-- <span class="content-check" @click="add">增加</span> -->
    <el-table
      :data="equipmentList"
      :class="{ noData: equipmentList.length == 0 }"
      style="width: 100%"
    >
      <i
        slot="empty"
        style="font-size:16px;
        color:#6baae6;
        "
      >
        <img
          src="../../assets/icon_data_empty.png"
          alt=""
        />
        <span>暂无数据</span>
      </i>
      <el-table-column
        prop="factory"
        label="设备品牌"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="iotId"
        label="UID号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="name"
        show-overflow-tooltip
        align="center"
        label="设备名称"
      >
      </el-table-column>
      <el-table-column
        prop="base"
        align="center"
        show-overflow-tooltip
        label="绑定基地"
      >
      </el-table-column>
      <el-table-column
        prop="pond"
        align="center"
        show-overflow-tooltip
        label="绑定塘口"
      >
      </el-table-column>
      <el-table-column
        prop="alarmPhone"
        align="center"
        width="150"
        show-overflow-tooltip
        label="警报电话"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        width="200"
        align="center"
      >
        <template slot-scope="scope">
          <span
            class="content-check"
            @click="check(scope.$index, scope.row)"
          >查看</span>
          <span
            class="content-calibrate"
            :class="{'calibrate':judgecalibrate(scope.row.sensorTypes)}"
            @click="calibration(scope.$index, scope.row)"
          >校准</span>
          <span
            class="content-edit"
            @click="edit(scope.$index, scope.row)"
          >编辑</span>
          <span
            class="content-delete"
            @click="handleDelete(scope.$index, scope.row)"
          >删除</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- <page-change :pageInfo="pageInfo"></page-change> -->
    <dialog-box
      :titleName="titleName"
      :showDialog="showDialog"
      :dialogWidth="dialogWidth"
      @changeShow="changeShow"
    >
      <div class="params-wrap">
        <i class="icon"></i>
        <span class="scope">品牌</span>
        <el-select
          v-model="equipmentValue.factory"
          :class="{disabled:disabled}"
          placeholder="请选择品牌"
        >
          <el-option
              v-for="(item,index) in factoryList"
              :key="index"
              :label="item.value"
              :value="item.value"
            >
          </el-option>
          <!-- <el-option
            label="信立XL-68"
            value="1"
          ></el-option>
          <el-option
            label="信立XL-70"
            value="2"
          ></el-option>
          <el-option
            label="信立XL-80"
            value="3"
          ></el-option> -->
        </el-select>
      </div>
      <div class="params-wrap">
        <i class="icon"></i>
        <span class="scope">UID号</span>
        <el-input
          v-model="equipmentValue.iotId"
          :maxlength="num30"
          :class="{disabled:disabled}"
          placeholder="请输入UID号"
          onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
        ></el-input>
      </div>
      <div class="params-wrap">
        <i class="icon"></i>
        <span class="scope">设备名称</span>
        <el-input
          v-model="equipmentValue.name"
          :maxlength="num20"
          placeholder="请输入设备名称,不超过10个字符"
          onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
        ></el-input>
      </div>
      <div class="params-wrap">
        <i class="icon"></i>
        <span class="scope">绑定基地</span>
        <el-select
          v-model="equipmentValue.fishBaseId"
          placeholder="请选择基地"
          @change="changeBase"
        >
          <el-option
            v-for="(item,index) in baseList"
            :key="index"
            :label="item.value"
            :value="item.key"
          ></el-option>
        </el-select>
      </div>
      <div class="params-wrap">
        <i class="icon"></i>
        <span class="scope">绑定塘口</span>
        <el-select
          v-model="equipmentValue.fishPondId"
          placeholder="请选择塘口"
          @change="changePond"
        >
          <el-option
            v-for="(item,index) in fishPond"
            :key="index"
            :label="item.value"
            :value="item.key"
          ></el-option>
        </el-select>
      </div>
      <div class="params-wrap">
        <span class="scope">警报电话</span>
        <el-input
          v-model="equipmentValue.alarmPhone"
          :maxlength="num11"
          placeholder="请输入警报电话"
          onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
        ></el-input>
      </div>
      <el-row>
        <el-button @click="cancel">取消</el-button>
        <el-button
          type="primary"
          @click="save"
        >保存</el-button>
      </el-row>
    </dialog-box>
  </div>
</template>

<script>
// import PageChange from '../components/common/PageChange'
import DialogBox from '../../components/common/DialogBox'
import indexModule from '../../store/modules/index'
import { Message } from 'element-ui'
import deviceSettingsModule from '../../store/modules/deviceSettings'
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  name: 'DeviceSettings',
  components: {
    // PageChange,
    DialogBox
  },
  data () {
    return {
      factoryList: [
        {
          value: '信立XL-68',
          key: 1
        }, {
          value: '信立XL-70',
          key: 2
        }, {
          value: '信立XL-80',
          key: 3
        }
      ],
      num30: 30,
      num20: 20,
      num11: 11,
      showDialog: false,
      titleName: '添加新设备',
      dialogWidth: '600px',
      value: '',
      input: '',
      disabled: false,
      equipmentValue: {
        factory: '',
        iotId: '',
        name: '',
        fishBaseId: '',
        fishPondId: '',
        userType: 2,
        photo: '',
        remark: '',
        alarmPhone: ''
      },
      baseList: [], // 基地列表
      fishPond: [] // 塘口列表
      // tableData: [
      //   {
      //     brand: '品牌',
      //     id: '123',
      //     name: '王小虎',
      //     base: '上海市',
      //     bond: '465'
      //   },
      //   {
      //     brand: '品牌',
      //     id: '123',
      //     name: '王小虎',
      //     base: '上海市',
      //     bond: '465'
      //   }
      // ],
      // pageInfo: {
      //   pageNumber: 1, // 当前页数
      //   totalPages: 0, // 总页数
      //   // pageFunc: this.getPondData, // 当前页数需要调用的函数
      //   pageSize: 10 // 当前页数
      // }
    }
  },
  watch: {
    // equipment () {
    //   this.tableData = this.equipment
    // }
  },
  async mounted () {
    this.bus.$on('addOneEquipment', title => {
      this.titleName = '添加新设备'
      this.showDialog = true
      this.disabled = false
      this.equipmentValue = {
        factory: '',
        iotId: '',
        name: '',
        fishBaseId: '',
        fishPondId: '',
        userType: 2,
        photo: '',
        remark: '',
        alarmPhone: ''
      }
    })
    this.baseList = await this.getBaseKeyValue()
  },
  computed: {
    ...mapState(indexModule, ['equipmentList', 'equipmentId'])

  },
  methods: {
    ...mapActions(deviceSettingsModule, ['getBaseKeyValue', 'getFishPond']),
    ...mapActions(indexModule, [
      'getEquipmentList',
      'addEquipment',
      'deleteEquipment',
      'updateEquipment',
      'getEditView',
      'editEquipment',
      'calibrationDissolvedOxygen'
    ]),
    ...mapMutations(indexModule, [
      'updateEquipmentList',
      'setSelectedEquipmentId'
    ]),
    judgecalibrate (arr = []) {
      if (arr == null) {
        return false
      }
      if (arr.includes(1)) {
        return true
      } else {
        return false
      }
    },
    async changeBase (index) {
      // 基地=>塘口 联动
      this.equipmentValue.fishPondId = ''
      this.fishPond = await this.getFishPond(this.equipmentValue.fishBaseId)
      this.equipmentValue.fishPondId = this.fishPond[0].key
    },
    changePond () {
      console.log(this.equipmentValue.fishPondId)
    },

    entry () {
      this.showDialog = true
    },
    changeShow () {
      this.showDialog = false
    },
    add () {
      this.showDialog = true
    },
    // 校准溶解氧
    calibration (index, row) {
      console.log(row)
      if (row.sensorTypes.includes(1) !== true) {
        return
      }
      this.$confirm(
        '该校准操作，会根据传感器当前温度空气中溶解氧的标准值进行校准。传感器需放置在空气中，静置一会，方可进行校准。是否立即开始校准',
        '',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          // type: 'warning'
          showClose: false
        }
      )
        .then(async () => {
          await this.calibrationDissolvedOxygen(row.id)
          this.$Alert.info({
            content: '校准完成',
            duration: 1000,
            status: 'success'
          })
          // this.equipmentList.splice(index, 1)
          // this.updateEquipmentList(index)
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 3000,
            status: 'error'
          })
        })
    },
    // 获取设备编辑视图
    async edit (index, row) {
      this.titleName = '编辑设备'
      this.disabled = true
      this.showDialog = true
      this.equipmentValue = {}
      let result = await this.getEditView(row.id)
      this.fishPond = await this.getFishPond(result.fishBaseId)

      this.equipmentValue = {
        index: index,
        rowId: row.id,
        factory: result.factory,
        iotId: result.iotId,
        name: result.name,
        fishBaseId: result.fishBaseId,
        fishPondId: result.fishPondId,
        userType: 2,
        photo: result.photo,
        remark: result.remark,
        alarmPhone: result.alarmPhone
      }
    },
    // 删除设备
    handleDelete (index, row) {
      this.$confirm('您确定删除当前选中的设备吗？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        // type: 'warning'
        showClose: false
      })
        .then(async () => {
          this.deleteEquipment(row.id)
          this.$Alert.info({
            content: '删除成功',
            duration: 1000,
            status: 'success'
          })
          // this.equipmentList.splice(index, 1)
          this.updateEquipmentList(index)
        })
        .catch(err => {
          console.log(err)
          this.$Alert.info({
            content: err.response.data,
            duration: 3000,
            status: 'error'
          })
        })
    },
    check (index, row) {
      this.$router.push({
        name: 'Index'
      })
      this.setSelectedEquipmentId(row.id)
      if (this.$route.path === '/deviceSettings') {
        this.bus.$emit('checkPath', false)
      } else {
        this.bus.$emit('checkPath', true)
      }
    },
    // 设备的更新与添加
    save () {
      let equipmentValue = JSON.parse(JSON.stringify(this.equipmentValue))
      if (this.titleName === '编辑设备') {
        let err = null
        let nameReg = /^.{1,10}$/
        if (!nameReg.test(equipmentValue.name)) {
          err = '设备名称范围:1-10个字符'
        }
        let alarmPhoneReg = /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\\d{8}$||''/
        if (!alarmPhoneReg.test(equipmentValue.alarmPhone)) {
          err = '请输入正确的手机号码'
        }
        if (!equipmentValue.factory) err = '品牌必须选择'
        if (!equipmentValue.iotId) err = 'UID号不为空'
        if (!equipmentValue.fishBaseId) err = '基地不为空'
        if (!equipmentValue.fishPondId) err = '塘口不为空'
        if (err) {
          Message.error(err)
          return
        }
        this.editEquipment({
          id: this.equipmentValue.rowId,
          equipmentValue: equipmentValue
        })
          .then(async () => {
            this.$Alert.info({
              content: '保存成功',
              duration: 1000,
              status: 'success'
            })
            this.showDialog = false
            this.equipmentValue = {}
            await this.getEquipmentList()
          })
          .catch(err => {
            Message.error(err.response.data)
          })
      } else if (this.titleName === '添加新设备') {
        let err = null
        let nameReg = /^.{1,10}$/
        if (!nameReg.test(equipmentValue.name)) {
          err = '设备名称范围:1-10个字符'
        }
        let alarmPhoneReg = /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\\d{8}$||''/
        if (!alarmPhoneReg.test(equipmentValue.alarmPhone)) {
          err = '请输入正确的手机号码'
        }
        if (!equipmentValue.factory) err = '品牌必须选择'
        if (!equipmentValue.iotId) err = 'UID号不为空'
        if (!equipmentValue.fishBaseId) err = '基地不为空'
        if (!equipmentValue.fishPondId) err = '塘口不为空'
        if (err) {
          Message.error(err)
          return
        }
        this.addEquipment(equipmentValue)
          .then(async () => {
            this.$Alert.info({
              content: '保存成功',
              duration: 1000,
              status: 'success'
            })
            this.showDialog = false
            this.equipmentValue = {}
            await this.getEquipmentList()
          })
          .catch(err => {
            Message.error(err.response.data)
          })
      }
      // this.showDialog = false
      // this.equipmentValue = {}
    },
    cancel () {
      this.showDialog = false
      this.disabled = false
    }
  }
}
</script>

<style lang="stylus">
.content-calibrate {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  margin-right: 20px;
  cursor: not-allowed;
  color: gray;
}

.calibrate {
  cursor: pointer;
  color: #45B6F6;
}

.el-table {
  border-top: none;

  .el-table__empty-text {
    i {
      margin-top: 113px;

      img {
        display: block;
        width: 228px;
        height: 218px;
      }

      span {
        display: block;
        margin-top: 10px;
      }
    }
  }
}

.noData {
  height: 540px;
}

.params-wrap {
  margin-bottom: 10px;

  .el-select.disabled, .el-select__caret.disabled {
    pointer-events: none;
  }

  .el-input__suffix, .disabled {
    .el-input__inner {
      pointer-events: none;
      border: 1px solid #0050AB;
      color: #6E8094 !important;
    }

    .el-input__suffix-inner {
      pointer-events: none;
    }

    .el-input__suffix {
      pointer-events: none;

      .el-icon-arrow-up:before {
        display: none;
      }
    }
  }

  .icon {
    position: absolute;
    width: 10px;
    height: 10px;
    margin-top: 14px;
    background: url('../../../public/images/star.png') no-repeat;
  }

  .scope {
    display: inline-block;
    width: 80px;
    margin-right: 10px;
    text-align: left;
    color: #bbd4e9;
    padding-left: 20px;
  }

  .el-input__inner {
    border: 1px solid #07f;
    color: #fff;
    background: none;
  }

  .el-input--suffix .el-input__inner {
    width: 460px;
    color: #fff;
    background: none;
  }

  .el-input {
    width: 460px;
    background: none;
  }
}

.el-row {
  margin-left: 90px;

  .el-button:hover {
    color: #bbd4e9;
    background: #07f;
    border: 1px solid #07f;
  }

  .el-button--default {
    background: none !important;
  }

  .el-button--primary:hover {
    border: 1px solid #07f;
    color: white;
  }
}

.el-message-box {

  padding-bottom: 20px;
  background: rgba(32, 48, 81, 1);
  border: 1px solid #2886F2;

  .el-message-box__content {
    .el-message-box__message {
      font-size: 16px;
      text-align: center;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(187, 212, 233, 1);
      margin-top: -10px;
      padding-bottom: 20px;
    }
  }

  .el-message-box__btns {
    text-align: center;

    .el-button--default:first-child {
      width: 120px;
      height: 40px;
      background: rgba(30, 63, 117, 0);
      border-radius: 4px;
    }

    .el-button--primary:last-child {
      width: 120px;
      height: 40px;
      background: rgba(255, 47, 47, 1);
      border-radius: 4px;
      border: 1px solid rgba(255, 47, 47, 1);
    }
  }
}
</style>
